/** Built-in voices for gpt-realtime-2.1. Marin is the default. */
export const AGENT_VOICES = [
  { id: 'marin', label: 'Marin', group: 'female' },
  { id: 'alloy', label: 'Alloy', group: 'female' },
  { id: 'coral', label: 'Coral', group: 'female' },
  { id: 'sage', label: 'Sage', group: 'female' },
  { id: 'shimmer', label: 'Shimmer', group: 'female' },
  { id: 'cedar', label: 'Cedar', group: 'male' },
  { id: 'ash', label: 'Ash', group: 'male' },
  { id: 'ballad', label: 'Ballad', group: 'male' },
  { id: 'echo', label: 'Echo', group: 'male' },
  { id: 'verse', label: 'Verse', group: 'male' },
] as const;

export const AGENT_VOICE_GROUPS = [
  { id: 'female', label: 'Female' },
  { id: 'male', label: 'Male' },
] as const;

export const DEFAULT_AGENT_VOICE = 'marin';

const IDS = new Set<string>(AGENT_VOICES.map((voice) => voice.id));

export function agentVoice(value: string | null | undefined): string {
  return value && IDS.has(value) ? value : DEFAULT_AGENT_VOICE;
}
